import Link from 'next/link';

import { BlockErrorMessage } from '../../../Block/BlockErrorMessage';
import { ButtonBase } from '../../../Button/ButtonBase';
import { InputText } from '../../../Form/InputText';
import { InnerButtonAreaTwoColumns } from '../../../Layout/InnerLayout/InnerButtonAreaTwoColumns';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';

import type { InvalidParam } from '../../../../types/InvalidParam';
import type { LoggedInUser } from '../../../../types/LoggedInUser';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC, ChangeEventHandler, FormEventHandler } from 'react';

export type EmailAlterationInvalidParam = InvalidParam & {
  name: 'newEmail';
};

export type EmailAlterationInvalidParams = EmailAlterationInvalidParam[];

export type EmailAlterationApplyContentsProps = {
  appEnv: AppEnv;
  invalidParams?: EmailAlterationInvalidParams;
  loggedInUser: LoggedInUser;
  disableSubmitButton?: boolean;
  errorMessage?: string;
  currentEmail: string;
  eventHandlers?: {
    changeNewEmail: ChangeEventHandler<HTMLInputElement>;
    submit: FormEventHandler<HTMLFormElement>;
  };
};

// eslint-disable-next-line max-lines-per-function
export const EmailAlterationApplyContents: FC<
  EmailAlterationApplyContentsProps
> = ({
  disableSubmitButton,
  invalidParams,
  errorMessage,
  currentEmail,
  eventHandlers,
}) => {
  const newEmailError = invalidParams?.find(
    (value) => value.name === 'newEmail',
  );

  return (
    <form method="post" onSubmit={eventHandlers?.submit}>
      <TableBody>
        <TableTrFormLabel
          id="email"
          required={false}
          title="登録しているメールアドレス"
        >
          <InputText
            name="email"
            id="email"
            type="email"
            width="default"
            placeholder=""
            defaultValue={currentEmail}
            disable
          />
        </TableTrFormLabel>
        <TableTrFormLabel
          id="newEmail"
          required={true}
          errorMessage={newEmailError?.reason ? newEmailError?.reason : ''}
          title="新しいメールアドレス"
        >
          <InputText
            name="newEmail"
            id="newEmail"
            type="email"
            width="default"
            placeholder="例)changed@nurse-senka.jp"
            onChange={eventHandlers?.changeNewEmail}
          />
        </TableTrFormLabel>
      </TableBody>
      {errorMessage ? (
        <BlockErrorMessage>{errorMessage}</BlockErrorMessage>
      ) : (
        ''
      )}
      <InnerButtonAreaTwoColumns>
        <Link href="/" prefetch={false} legacyBehavior={true}>
          <ButtonBase color="secondary" width="wide">
            戻る
          </ButtonBase>
        </Link>
        <ButtonBase
          color="primary"
          width="wide"
          disable={disableSubmitButton === true}
        >
          確認メールを送信
        </ButtonBase>
      </InnerButtonAreaTwoColumns>
    </form>
  );
};
